import ApiClient from "./apiClient";

const messageTemplatesService = {
  list: (params?: Record<string, any>) =>
    ApiClient.get("message_templates", { params }),

  get: (id: number | string) => ApiClient.get(`message_templates/${id}`),

  create: (data: Record<string, any>) =>
    ApiClient.post("message_templates", data),

  update: (id: number | string, data: Record<string, any>) =>
    ApiClient.put(`message_templates/${id}`, data),

  delete: (id: number | string) =>
    ApiClient.delete(`message_templates/${id}`),

  getCreateOptions: () =>
    ApiClient.get("message_templates/create_options"),

  getEditableTemplates: (templateId: number | string) =>
    ApiClient.get("message_templates/get_editable_message_templates", {
      params: { template_id: templateId },
    }),

  createLanguageTemplate: (name: string, language: string) =>
    ApiClient.post("message_templates", {
      name,
      language,
    }),

  updateTemplatesSet: (templates: any[]) =>
    ApiClient.post("message_templates/update_templates_set", templates),
};

export default messageTemplatesService;
